import React from 'react'
import { InputParameterHierarchyType, MeetingAgendaInputParameters } from './model'
import { MeetingTemplateInputParametersHierarchyConfigModal } from './MeetingTemplateInputParametersHierarchyConfigModal'
import { MeetingTemplateGlobalInputParameterConfigForm } from './Form/MeetingTemplateGlobalInputParameterConfigForm'
import { MeetingTemplateCurrentUserInputParameterConfigForm } from './Form/MeetingTemplateCurrentUserInputParameterConfigForm'
import { MeetingTemplateTeamMemberInputParameterConfigForm } from './Form/MeetingTemplateTeamMemberInputParameterConfigForm'

export interface MeetingAgendaInputParametersHierarchyConfigModalProps {
  show: boolean
  onHide: () => void
  meetingTemplateId: string
  defaultInputParameters: MeetingAgendaInputParameters | null
}

const INPUT_PARAMETERS_SCHEMA = {
  useIconLayout: true,
  properties: {
    fixed: {
      title: 'Fixed topics',
      type: 'array',
      description: 'Add specific items you want to discuss in meetings using this template.',
      icon: 'bi-list-ul',
      items: {
        type: 'string',
      },
    },
    customInstructions: {
      title: 'Custom instructions to AI Assistant',
      type: 'string',
      description: 'Write a custom prompt for the AI Assistant to generate agenda items tailored to this Meeting Type.',
      icon: 'bi-stars',
    },
  },
}

export const MeetingAgendaInputParametersHierarchyConfigModal: React.FC<MeetingAgendaInputParametersHierarchyConfigModalProps> = ({
  show,
  onHide,
  meetingTemplateId,
  defaultInputParameters,
}) => {
  return (
    <MeetingTemplateInputParametersHierarchyConfigModal
      show={show}
      onHide={onHide}
      type={InputParameterHierarchyType.MEETING_AGENDA_CONFIG}
      typeId={'agenda-conf'}
      name={'Meeting Agenda Template'}
      inputParametersSchema={INPUT_PARAMETERS_SCHEMA}
      defaultInputParameters={defaultInputParameters}
      meetingTemplateId={meetingTemplateId}
      MeetingTemplateConfig={MeetingTemplateGlobalInputParameterConfigForm}
      CurrentUserConfig={MeetingTemplateCurrentUserInputParameterConfigForm}
      TeamMembersConfig={MeetingTemplateTeamMemberInputParameterConfigForm}
    />
  )
}
